import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {environment} from "../../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceModeGuard implements CanActivate {
  mainteanaceMode = environment.maintenance;
  constructor( private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.mainteanaceMode){
      return true;
    }
    const access = localStorage.getItem('maintenance-access');
    console.log(access);
    if (access === 'true') {
      return true;
    } else {
      this.router.navigate(['/maintenance']);
      return false;
    }
  }
}
